module.exports = __webpack_public_path__ + "background4.jpg";